<template>
  <v-container>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.min, rules.max]"
            :label="$t('DeviceTypes.name')"
            hint="Between 3 and 30 characters"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea v-model="description" auto-grow rows="1">
            <template v-slot:label>
              <div>
                {{$t('DeviceTypes.description')}}
                <small>{{$t('DeviceTypes.optionnal')}}</small>
              </div>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <save-buttons
      :deviceTypeToUpdate="deviceTypeToUpdate"
      :deviceTypeId="deviceTypeId"
      :path="path"
      @back="$emit('backinfo')"
      @error="error"
      @saved="saved"
    ></save-buttons>
  </v-container>
</template>

<script>
import SaveButtonsComponent from "./SaveButtons.vue";

export default {
  components: {
    "save-buttons": SaveButtonsComponent
  },
  props: {
    choosenDeviceType: Object,
    path: String
  },
  computed: {
    deviceTypeToUpdate: function() {
      let json = {
        valid: this.valid
      };
      if (this.description != "") json.description = this.description;
      if (this.name != "") json.name = this.name;
      return json;
    },
    deviceTypeId: function() {
      return this.choosenDeviceType.deviceTypeId;
    }
  },
  data() {
    return {
      name: "",
      description: "",
      valid: false,
      rules: {
        min: v =>
          v.length >= 3 || v.length == 0 || this.$t("DeviceTypes.rules.min"),
        max: v => v.length <= 30 || this.$t("DeviceTypes.rules.max")
      }
    };
  },
  methods: {
    error: function(value) {
      this.$emit("error", value);
    },
    saved: function(value) {
      this.$emit("saved", value);
    }
  },
  mounted: function() {
    this.name = this.choosenDeviceType.name;
    this.description = this.choosenDeviceType.description;
  }
};
</script>